<template>
  <div>
    <el-table :data="items" size="small" class="mt-10">
      <el-table-column align="left" label="名称" prop="name">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <el-tag size="mini" type="primary" v-if="scope.row.type == 2"
            >耗材</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="配件属性"
        prop="code"
        min-width="300"
      >
        <template slot-scope="scope">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item>编号</el-breadcrumb-item>
            <el-breadcrumb-item>名称</el-breadcrumb-item>
            <el-breadcrumb-item>型号</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="(item, index) in scope.row.custom_params"
              :key="item.label + index"
              >{{ item.label }}</el-breadcrumb-item
            >
            <el-breadcrumb-item>期初使用时间</el-breadcrumb-item>
            <el-breadcrumb-item>状态</el-breadcrumb-item>
            <el-breadcrumb-item>平均寿命</el-breadcrumb-item>
            <el-breadcrumb-item>备注</el-breadcrumb-item>
          </el-breadcrumb>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="平均寿命"
        prop="age"
        width="80"
        align="center"
      ></el-table-column> -->
      <!-- <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">{{
          $time(scope.row.created_at).format('YYYY-MM-DD')
        }}</template>
      </el-table-column> -->
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-if="scope.row.item_count == 0"
            title="确认删除该配件分类吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                category == 1
                  ? Auth.itemTemplateDelete
                  : Auth.instrumentItemTemplateDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>

          <el-link
            v-permission="
              category == 1
                ? Auth.itemTemplateEdit
                : Auth.instrumentItemTemplateEdit
            "
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            @click.native="editItem(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            v-permission="
              category == 1
                ? Auth.itemTemplateDetail
                : Auth.instrumentItemTemplateDetail
            "
            class="font-12 ml-5"
            type="primary"
            :underline="false"
            @click="$router.push(`${$route.path}/${scope.row.id}`)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></item-former>
  </div>
</template>

<script>
import { itemTemplateDelete } from '@/service/getData'
import ItemFormer from './former'

export default {
  components: {
    ItemFormer,
  },
  props: {
    items: null,
    category: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      model: {},
      formerVisible: false,
      detailVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    editItem(item, index) {
      let cloneItem = this.clone(item)
      cloneItem.custom_params.map((item) => {
        if (!item.type) {
          item.type = 1
          item.options = ''
        }
      })
      this.model = cloneItem
      this.editIndex = index
      this.formerVisible = true
    },
    handleShow(item) {
      this.model = item
      this.detailVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },
    async hanldeDelte(item, index) {
      let res = await itemTemplateDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },
  },
}
</script>